import { render, staticRenderFns } from "./EditPricelistItem.vue?vue&type=template&id=5fe0aa1c&scoped=true"
import script from "./EditPricelistItem.vue?vue&type=script&lang=js"
export * from "./EditPricelistItem.vue?vue&type=script&lang=js"
import style0 from "./EditPricelistItem.vue?vue&type=style&index=0&id=5fe0aa1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0aa1c",
  null
  
)

export default component.exports